<template>
  <a-modal
    title="导入产品"
    :visible="visible"
    v-if="visible"
    @cancel="cancel"
    @ok="ok"
    :maskClosable="false"
    width="1000px"
    destroyOnClose
  >
    <a-space style="margin-bottom: 10px;">
      <a-select v-model="form.factoryId" style="width: 200px" placeholder="请选择工厂" @change="() => getList({current: 1,pageSize:pagination.pageSize})">
        <a-select-option v-for="item in factoryData" :key="item.factoryId" :value="item.factoryId">
          <a-tooltip size="small">
            {{ item.name }}
            <template slot="title">{{ item.name }}</template>
          </a-tooltip>
        </a-select-option>
      </a-select>
      <a-input v-model="form.productKeyword" placeholder="产品名称/代码" @pressEnter="() => getList({current: 1,pageSize:pagination.pageSize})" @change="changeSearch" style="width: 200px">
        <a-tooltip slot="suffix" title="查询">
          <a-icon type="search" style="cursor: pointer;color: rgba(0,0,0,.45)" @click="() => getList({current: 1,pageSize:pagination.pageSize})" />
        </a-tooltip>
      </a-input>
      <a-select v-model="form.formulaType" style="width: 200px" placeholder="配方类型" @change="() => getList({current: 1,pageSize:pagination.pageSize})">
        <a-select-option value="1">配合饲料</a-select-option>
        <a-select-option value="2">混合日粮</a-select-option>
        <!-- <a-select-option value="4">定制料</a-select-option> -->
      </a-select>
    </a-space>
    <a-table 
      bordered
      row-key="id"
      :pagination="pagination"
      :row-selection="rowSelection"
      :scroll="{x: 100,y: 300}"
      :dataSource="list"
      :columns="columns"
      @expand="getChildList"
      :expanded-row-keys.sync="expandedRowKeys"
    >
      <template slot="isActivate" slot-scope="text">
        {{text == 1 ? '是' : '否'}}
      </template>
      <template slot="isPushEbs" slot-scope="text">
        {{text == 1 ? '是' : '否'}}
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: ['visible','allIds','allList'],
  data(){
    return {
      expandedRowKeys: [],
      selectedRowKeys: [],
      selectedRows: [],
      maxLen: 50,
      list: [],
      pagination: {
        total:0,
        pageSize:20,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `总共${total}个产品`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.getList({current,pageSize})
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this.getList({current: 1,pageSize})
        } //每页多少条
      },
      columns: [
        // {
        //   dataIndex:'factoryName',
        //   title:"工厂名称",
        //   sorter: (a, b) => a.factoryName.localeCompare(b.factoryName,'zh'),
        //   width: 300,
        //   ellipsis: true,
        // },
        {
          dataIndex:'productName',
          title:"产品名称",
          // sorter: (a, b) => a.productName.localeCompare(b.productName,'zh'),
          width: 120,
          ellipsis: true,
        },
        {
          dataIndex:'formulaCode',
          title:"配方代码",
          width: 100,
        },
        // {
        //   dataIndex:'animalTypeName',
        //   title:"动物类型",
        //   sorter: (a, b) => a.animalTypeName.localeCompare(b.animalTypeName,'zh'),
        //   width: 100,
        // },
        {
          dataIndex:'version',
          title:"版本",
          // sorter: (a, b) => a.version - b.version,
          width: 60,
        },
        {
          dataIndex:'isActivate',
          title:"是否激活",
          scopedSlots: {customRender: 'isActivate'},
          width: 70,
        },
        {
          dataIndex:'isPushEbs',
          title:"是否推送",
          scopedSlots: {customRender: 'isPushEbs'},
          // sorter: (a, b) => a.isPushEbs - b.isPushEbs,
          width: 70,
        },
        {
          dataIndex:'pushTime',
          title:"推送时间",
          // sorter: (a, b) => new Date(a.pushTime).getTime() - new Date(b.pushTime).getTime(),
          width: 120
        },
        {
          dataIndex:'createTime',
          title:"创建时间",
          // sorter: (a, b) => new Date(a.createTime).getTime() - new Date(b.createTime).getTime(),
          width: 120
        },
      ],
      form: {},
      timer: null,
    }
  },
  computed:{
    ...mapState('home',['factoryData']),
    rowSelection() {
      return {
        selectedRowKeys:this.selectedRowKeys,
        onChange: (selectedRowKeys,selectedRows) => {
          selectedRowKeys = selectedRowKeys.splice(0,this.maxLen);
          this.selectedRowKeys = selectedRowKeys
          let arr = [...this.selectedRows, ...selectedRows]
          this.selectedRows = selectedRowKeys.map(i => {
            return arr.filter(item=>item.id === i)[0]
          })
          this.list = [...this.list]
        },
        getCheckboxProps: record => ({
          props: {
            disabled: !this.selectedRowKeys.includes(record.id) && this.selectedRowKeys.length >= this.maxLen
          },
        }),
      }
    },
  },
  watch: {
    visible(val) {
      if(val) {
        this.selectedRowKeys = [...this.allIds]
        this.selectedRows = [...this.allList]
        this.expandedRowKeys = []
        this.form = {
          factoryId: window.localStorage.getItem('factoryId'),
          formulaCode: undefined,
          formulaType: '1',
          productKeyword: undefined,
        }
        this.getList({current: 1,pageSize:20})
      }
    },
  },
  methods: {
    changeSearch(){
      if(this.timer) return
      this.timer = setTimeout(() => {
        this.timer = null
        this.getList({current: 1,pageSize: this.pagination.pageSize})
      }, 500);
    },
    getChildList(status,item){
      if(status){
        this.expandedRowKeys = [...this.expandedRowKeys,item.id]
        const {formulaCode} = item
        let params = {
          formulaCode,factoryId: this.form.factoryId,size: 100,status: 0,isActivate: 0
        }
        this.$http.get('/nhf-app/formulaproduct/selectFormulaProductPageByCond',{params}).then(res => {
        let {success,data} = res || {}
        if(success){
          let {records} = data;
          item.children = records || []
        }
      })
      } else{
        this.expandedRowKeys = this.expandedRowKeys.filter(el => el.id !== item.id)
      }
    },
    getList(pagination){
      let {current=1,pageSize=20} = pagination || this.pagination
      let params = {
        current,size:pageSize,
        ...this.form,
        isActivate: 1, // 激活
        status: 0, // 显示
      }
      this.$http.get('/nhf-app/formulaproduct/selectFormulaProductPageByCond',{params}).then(res => {
        let {success,data} = res || {}
        if(success){
          let {records,current=1,total=0,size=20} = data;
          this.pagination.current = current
          this.pagination.total = total
          this.pagination.pageSize = size
          this.list = records.map(i=>{
            if(i.isActivate && i.status === 0){return {...i,children: []}}
            else{return {...i}}
          }) || []
        }
      })
    },
    ok() {
      this.$emit('close',this.selectedRows)
    },
    cancel(){
      this.$emit('close',false)
    }
  }
}
</script>